import { useSelector } from 'react-redux';
import NavBar from 'components/pageLayout/navBar/NavBar';
import Text from 'components/typography/Text';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import style from '../../sass/style.module.scss';

export default function Header({ clientDisplayName = '', agentFullName = '' }) {
  const { whiteLabelSettings: { overviewImage = '' } = {} } =
    useWhiteLabelSettings();
  const { componentConfig } = useSelector(
    (state) => state.ui,
  );

  const headerBgStyle = overviewImage
    ? { backgroundImage: `url(${overviewImage})` }
    : {};

  const headerClassNames = overviewImage
    ? 'bg-cover bg-no-repeat bg-right-top'
    : style.overviewPageHeader;

  return (
    <header
      style={headerBgStyle}
      className={`${headerClassNames} h-[50vh] flex flex-col justify-between lg:h-[45vh] 2xl:h-[50vh]`}
    >
      <NavBar /> 
      <div className={`pl-7 text-white gradient-overlay ${componentConfig.contactAgentEnabled ? 'pb-7' : 'pb-16'}`}>
        <div className="font-medium flex flex-col text-5xl sm:flex-row lg:text-[75px]">
          {clientDisplayName && (
            <><Text className="mr-2">Hello,</Text><Text>{clientDisplayName}</Text></>
          )}
        </div>
        {agentFullName && componentConfig.contactAgentEnabled && (
          <div className="mt-[20px] text-lg">Your agent - {agentFullName}</div>
        )}
      </div>
    </header>
  );
}
